<template>
  <div class="tw-shadow" style="height: 100%;">

    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0">
      <b-tabs card fill>
        <b-tab v-for="(tab, key) in fullData" :title="key" :key="key" :ref="`canvasContainer-${key}`" :active="key === defaultSelected">
          <h6 class="tw-font-bolder tw-mb-0 text-center tw-mb-3">Overall New Infections</h6>

          <!-- <svg :ref="`mySVG-${key}`" width="300" height="300"></svg> -->
          <h1 class="tw-text-center tw-text-6xl">
              {{ tab.newInfections }}
          </h1>

          <br><hr><br>

          <h6 class="tw-font-bolder tw-mb-0 text-center tw-mb-3">First Time Infections</h6>
          <h1 class="tw-text-center tw-text-6xl">
              {{ tab.firstTimeInfections }}
          </h1>
          <h6 class="tw-font-normal tw-mt-3 text-center" v-if="key == 'Cohort 1'">
            Interim Analysis Target
            <span class="tw-font-semibold">{{ accumulatedInfections }} / {{ targetInfections }}</span>
          </h6>
          <h6 class="tw-font-normal tw-mt-3 text-center" v-if="key == 'Cohort 2'">
            Final Analysis Target
            <!-- <span class="tw-font-semibold">{{ accumulatedInfections }} / {{ targetInfections }}</span> -->
            <!-- Hard-coded '1056' because it's only used on this page in this tab... -->
            <span class="tw-font-semibold">{{ accumulatedInfections }} / 1056</span>
          </h6>
        </b-tab>
      </b-tabs>
      
      <div class="tw-mt-auto tw-flex tw-justify-end">
        <info-popover>
          <template v-slot:title>
            New Infections
          </template>

          <p>The total number of new infections in the study and the target new infections.</p>
        </info-popover>
      </div>
    </b-card>

  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

// import {
//     mapState, mapGetters, mapActions
// } from 'vuex';

import * as d3 from "d3";
import * as _ from 'lodash';

export default {
  mixins: [],
  components: {},
  props: {},
  data: function() {
    return {
      defaultSelected: "Cohort 2",
      targetInfections: 528,
      newInfections: 400,
      accumulatedInfections: 0,
      fullData: {},
      newInfectionsData: {},
      firstTimeInfectionsData: {},
    };
  },
  computed: {
    // ...mapState('sample', ['sample'])
  },
  created: function() {
    this.get();
  },
  mounted: function() {
    // // Redraw when resized.
    // window.addEventListener("resize", _.debounce(function() {
    //   that.draw();
    // }, 200));
  },
  methods: {
    get: async function() {
      const that = this;
      const fullData = {};

      that.newInfectionsData = await HTTP.get("/kenya/metrics/new-infections").then(response => response.data);
      that.firstTimeInfectionsData = await HTTP.get("/kenya/metrics/first-time-infections").then(response => response.data);

      _.each(that.newInfectionsData, (newInfections, studyPhase) => {
        fullData[studyPhase] = {
          newInfections: newInfections,
          firstTimeInfections: that.firstTimeInfectionsData[studyPhase]
        };

        if(studyPhase !== 'Baseline') {
          that.accumulatedInfections += that.firstTimeInfectionsData[studyPhase];
        }
      });

      that.fullData = fullData;

    },
    draw: function(studyPhase, phaseNewInfections) {
      // var c = document.getElementById("myCanvas");
      // var canvas = this.$refs.myCanvas;
      // var ctx = canvas.getContext("2d");
      // canvas.width = width;
      // canvas.height = height;
      // var that = this;

    var parentElementRef = this.$refs[`canvasContainer-${studyPhase}`]

      var mySVG = this.$refs[`mySVG-${studyPhase}`];

      if (!mySVG) {
        return;
      }

      // var padding = mySVG.parentElement.clientWidth * 0.05;

      parentElementRef = this.$refs[`canvasContainer-${studyPhase}`].clientWidth;
      var width = parentElementRef.clientWidth - (parentElementRef.clientWidth * 0.1);
      var height = width;

      var centerX = width / 2;
      var centerY = height / 2;

      var outerRadius = centerX;
      var innerRadius = outerRadius - 50;

      var tau = 2 * Math.PI;
      var offsetAngle = Math.PI / 2;
      var endAngle =
        (phaseNewInfections / this.targetInfections) * 2 * Math.PI -
        offsetAngle;

      const svg = d3
        .select(mySVG)
        // .style("background-color", "whitesmoke")
        .attr("width", width)
        .attr("height", height);

      svg.selectAll("*").remove();

      var g = svg
        .append("g")
        .attr("transform", "translate(" + centerX + "," + centerY + ")");

      svg
        .append("text")
        .attr("x", centerX)
        .attr("y", centerY + 25)
        .attr("text-anchor", "middle")
        .attr("fill", "white")
        .attr("font-family", "sans-serif")
        .attr("font-size", "4em")
        .text(0)
        .transition()
        .attr("fill", "black")
        .duration(4000)
        .tween("text", infectionsTween(phaseNewInfections));

      function infectionsTween(newInfections) {
        return function() {
          var interpolate = d3.interpolate(this.textContent, newInfections);
          return function(t) {
            this.textContent = Math.round(interpolate(t));
          };
        };
      }

      var arc = d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius(outerRadius)
        .startAngle(0);

      g.append("path")
        .datum({ endAngle: tau })
        .style("fill", "#ddd")
        .attr("d", arc);

      var foreground = g
        .append("path")
        .datum({ endAngle: -offsetAngle })
        .style("fill", "#37B1CA")
        .attr("d", arc.startAngle(-Math.PI / 2));

      foreground
        .transition()
        .duration(3000)
        .attrTween("d", arcTween(endAngle));

      function arcTween(newAngle) {
        return function(d) {
          var interpolate = d3.interpolate(d.endAngle, newAngle);

          return function(t) {
            d.endAngle = interpolate(t);
            return arc(d);
          };
        };
      }
    }
  }
};
</script>
